import { Card, CardContent, CardHeader, Box, Typography, Stack, Tooltip } from '@mui/material';
import { FilterAlt as FilterAltIcon } from '@mui/icons-material';

interface MetricsChartCardProps {
    title: string;
    children: React.ReactNode;
    height?: number;
    filtered?: boolean;
    filteredLabel?: string;
    action?: React.ReactNode;
}

export const MetricsChartCard = ({
    title,
    children,
    height = 260,
    filtered,
    filteredLabel = 'Filtered by user',
    action,
}: MetricsChartCardProps) => (
    <Card sx={{ height: '100%' }}>
        <CardHeader
            title={
                <Stack direction="row" sx={{ alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                    <Typography variant="subtitle1" fontWeight={600} sx={{ flex: 1, minWidth: 0 }}>
                        {title}
                    </Typography>
                    {filtered && (
                        <Tooltip title={filteredLabel} placement="top">
                            <FilterAltIcon
                                sx={{ fontSize: 14, color: 'text.disabled', opacity: 0.6 }}
                            />
                        </Tooltip>
                    )}
                    {action && <Box sx={{ ml: 'auto' }}>{action}</Box>}
                </Stack>
            }
            sx={{ pb: 0 }}
        />
        <CardContent sx={{ pt: 1 }}>
            <Box sx={{ height }}>{children}</Box>
        </CardContent>
    </Card>
);
